module.exports = __webpack_public_path__ + "static/img/fm3.0094814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm3.jpg
// module id = 7C4u
// module chunks = 1